var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Mixins } from 'vue-property-decorator';
import VeeValidate from 'vee-validate';
import { ProfileService } from '@/services/profile-service';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { AsYouType, parsePhoneNumber } from 'libphonenumber-js';
import { UserService } from '@/services/user-management/user-service';
import { UtilsService } from '@/services/utils-service';
import SnackbarMixin from '@/mixins/snackbar-mixin';
Vue.use(VeeValidate);
var ContactEdit = /** @class */ (function (_super) {
    __extends(ContactEdit, _super);
    function ContactEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.submitLoading = false;
        _this.initialEmail = '';
        _this.item = {
            firstName: '',
            lastName: '',
            email: '',
            disableEmailNotifications: false,
            officePhone: '',
            officePhoneExt: '',
            cellPhone: '',
        };
        _this.validationRules = {};
        _this.officePhoneNumber = new AsYouType('US');
        _this.officePhoneNumberExtensionEnabled = false;
        _this.cellPhoneNumber = new AsYouType('US');
        return _this;
    }
    ContactEdit.prototype.validate = function (scope) {
        var _this = this;
        this.$validator.validateAll(scope).then(function (result) {
            if (result) {
                _this.save();
            }
        });
    };
    ContactEdit.prototype.created = function () {
        var _this = this;
        // initialize
        this.validationRules = this.userService.getValidationRules();
        // check for duplicate email
        this.$validator.extend('isExistingEmail', {
            getMessage: function (field) { return field + " is already being used"; },
            validate: function (value, args) { return __awaiter(_this, void 0, void 0, function () {
                var isExistingEmail;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.initialEmail !== value)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.userService.isExistingEmail(value)];
                        case 1:
                            isExistingEmail = _a.sent();
                            return [2 /*return*/, isExistingEmail === false];
                        case 2: return [2 /*return*/, true];
                    }
                });
            }); },
        });
        this.$validator.extend('phoneNumber', {
            getMessage: function (field) { return field + " is not a valid phone number"; },
            validate: function (value, args) {
                try {
                    var phone = parsePhoneNumber(value, 'US');
                    return phone.isValid();
                }
                catch (_a) {
                    return false;
                }
            },
        });
    };
    ContactEdit.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactEdit.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationResult, data, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        this.submitLoading = true;
                        return [4 /*yield*/, this.$validator.validate('profile_edit.*')];
                    case 1:
                        validationResult = _a.sent();
                        if (!validationResult) return [3 /*break*/, 3];
                        data = __assign({}, this.item);
                        data.officePhone =
                            data.officePhoneExt && data.officePhoneExt.length > 0
                                ? this.officePhoneNumber.getNationalNumber() + "x" + data.officePhoneExt
                                : this.officePhoneNumber.getNationalNumber();
                        data.cellPhone = this.cellPhoneNumber.getNationalNumber();
                        return [4 /*yield*/, this.profileService.saveContactVm(data)];
                    case 2:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        // set initial email to new email
                        this.initialEmail = data.email;
                        this.showSnackbar({
                            text: 'Contact details changes saved',
                            color: 'success',
                        });
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to save contact details',
                            color: 'error',
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        this.submitLoading = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ContactEdit.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, parsedOfficePhoneNumberResult, parsedCellPhoneNumberResult, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        return [4 /*yield*/, this.profileService.getContactVm()];
                    case 1:
                        response = _a.sent();
                        this.item = response;
                        // save the initial e-mail
                        this.initialEmail = this.item.email;
                        parsedOfficePhoneNumberResult = this.utilsService.getFormattedPhoneNumber(this.item.officePhone);
                        if (parsedOfficePhoneNumberResult.success) {
                            this.formattedOfficePhoneNumber =
                                parsedOfficePhoneNumberResult.data.number;
                            this.item.officePhoneExt = parsedOfficePhoneNumberResult.data.extension;
                        }
                        else {
                            this.formattedOfficePhoneNumber = '';
                            this.$validator.errors.add({
                                field: 'officePhone',
                                scope: 'profile_edit',
                                msg: parsedOfficePhoneNumberResult.message,
                            });
                        }
                        parsedCellPhoneNumberResult = this.utilsService.getFormattedPhoneNumber(this.item.cellPhone);
                        if (parsedCellPhoneNumberResult.success) {
                            this.formattedCellPhoneNumber = parsedCellPhoneNumberResult.data.number;
                        }
                        else {
                            this.formattedCellPhoneNumber = '';
                            this.$validator.errors.add({
                                field: 'cellPhone',
                                scope: 'profile_edit',
                                msg: parsedCellPhoneNumberResult.message,
                            });
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        this.showSnackbar({
                            text: 'Unable to get contact details',
                            color: 'error',
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContactEdit.prototype, "formattedOfficePhoneNumber", {
        get: function () {
            return this.item.officePhone;
        },
        set: function (newValue) {
            var _this = this;
            try {
                this.officePhoneNumber.reset();
                this.item.officePhone = this.officePhoneNumber.input(newValue);
                if (this.officePhoneNumber.getNationalNumber() === '') {
                    // set the office phone to the original input for validation
                    this.item.officePhone = newValue;
                    // clear office phone extension input, invalidated
                    this.$nextTick(function () {
                        _this.invalidateOfficePhoneExtension();
                    });
                }
                else if (this.officePhoneNumber.getNumber() &&
                    this.officePhoneNumber.getNumber().isValid() === false) {
                    // clear office phone extension input, invalidated
                    this.$nextTick(function () {
                        _this.invalidateOfficePhoneExtension();
                    });
                }
                else {
                    this.officePhoneNumberExtensionEnabled = true;
                }
            }
            catch (error) {
                this.item.officePhone = newValue;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactEdit.prototype, "formattedCellPhoneNumber", {
        get: function () {
            return this.item.cellPhone;
        },
        set: function (newValue) {
            try {
                this.cellPhoneNumber.reset();
                this.item.cellPhone = this.cellPhoneNumber.input(newValue);
                if (this.cellPhoneNumber.getNationalNumber() === '') {
                    // set the cell phone to the original input for validation
                    this.item.cellPhone = newValue;
                }
            }
            catch (error) {
                this.item.cellPhone = newValue;
            }
        },
        enumerable: false,
        configurable: true
    });
    ContactEdit.prototype.invalidateOfficePhoneExtension = function () {
        this.item.officePhoneExt = '';
        this.officePhoneNumberExtensionEnabled = false;
    };
    var _a, _b, _c;
    __decorate([
        lazyInject(TYPES.ProfileService),
        __metadata("design:type", typeof (_a = typeof ProfileService !== "undefined" && ProfileService) === "function" ? _a : Object)
    ], ContactEdit.prototype, "profileService", void 0);
    __decorate([
        lazyInject(TYPES.UserService),
        __metadata("design:type", typeof (_b = typeof UserService !== "undefined" && UserService) === "function" ? _b : Object)
    ], ContactEdit.prototype, "userService", void 0);
    __decorate([
        lazyInject(TYPES.UtilsService),
        __metadata("design:type", typeof (_c = typeof UtilsService !== "undefined" && UtilsService) === "function" ? _c : Object)
    ], ContactEdit.prototype, "utilsService", void 0);
    ContactEdit = __decorate([
        Component({
            $_veeValidate: { validator: 'new' },
        })
    ], ContactEdit);
    return ContactEdit;
}(Mixins(SnackbarMixin)));
export default ContactEdit;
